














import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({
    components: {

    }
}) export default class ServiceCenterContents extends Mixins(VueHoduCommon) {

    mounted() : void {

    }

    /**
     * 고객센터 탭 변경
     */
    changeServiceCenterTab(tab : string) : void {
        this.doSetServiceCenterTab(tab);
    }

}

